import React, { FC } from "react";
import HeaderDashboardLayout from "../../../../components/layouts/headerDashboardLayout/HeaderDashboardLayout";
import ItemList from "../../../../components/elements/itemList/ItemList";
import List from "../../../../components/elements/list/List";

import { useTypedSelector } from "../../../../hooks/useTypedSelector";

import { Rotate, TextType } from "../../../../types/baseType";
import Tx from "../../../../types/naming";

import st from "./styles.module.scss";
import { CropCondition } from "../../../../types/service/dashboard/IScoutingDashboardService";
import Sticker from "../../../../components/elements/sticker/Sticker";
import FlexLine from "../../../../components/elements/flexLine/FlexLine";
import ChartHeader from "../../../../components/elements/chart/ChartHeader";
import Container from "../../../../components/elements/container/Container";
import LinearChart from "../../../../components/modules/dashboards/сharts/defaultCharts/linearChart/LinearChart";
import * as Highcharts from "highcharts";
import { stickerLoadingWithCrop } from "../../phases";
import { stateCropSelector } from "../index";
import Scrollbar from "../../../../utils/highchart/Scrollbar";
import { CropsConditionState } from "../../../../store/reducers/dashboard/cropscondition/types";
import { applyTip, checkWindowSize, wideFontSize24 } from "../../../../utils/utils";
import { withLayout } from "../../DashboardPage";
import { Empty } from "./empty";
import { array } from "fp-ts";
import { formatNumber2d } from "@utils/format/number";
import InlineTooltip from "@modules/dashboards/dashboardTooltips/TooltipVariants/InlineTooltip/InlineTooltip";

interface StateCropsDetailedPage {
    children: any;
}

const chartOptionsBy: (el: CropCondition) => Highcharts.Options = (el: CropCondition) => ({
    chart: {
        height: checkWindowSize(800, 249),
        spacingBottom: 2,
        zooming: {
            type: 'x',
            // @ts-ignore
            mouseWheel: {
                enabled: false
            },
            resetButton: {
                theme: {
                    zIndex: 99
                }
            }
        }
    },
    title: {
        text: ''
    },
    xAxis: {
        type: 'datetime',
        labels: {
            style: {
                fontSize: wideFontSize24(),
                color: 'rgba(85, 87, 89, 1)'
            }
        },
        scrollbar: Scrollbar(),
        lineColor: 'rgba(205, 206, 209, 1)',
        tickColor: 'rgba(205, 206, 209, 1)'
    },
    yAxis: {
        labels: {
            style: {
                fontSize: wideFontSize24()
            }
        },
        type: "linear",
        title: { text: "" }
    },
    tooltip: applyTip((ctx) =>
        <InlineTooltip value={`${formatNumber2d(ctx.y)} Га`} />, {
        followPointer: true
    }),
    credits: {
        enabled: false
    },
    legend: {
        enabled: false,
    },
    series: [
        {
            data: el.values.slice(),
            type: "spline",
            marker: { enabled: false },
            color: el.color,
            lineWidth: checkWindowSize(3, 1)
        }
    ]
} as Highcharts.Options)

const StateCropsSticker: FC<{ condition: CropCondition }> = ({ condition}) => {
    return  <Sticker>
        <FlexLine textType={TextType.Header}>
            <ChartHeader>{condition.type}</ChartHeader>
        </FlexLine>
        <Container>
            <LinearChart
                isStock
                isHcMore
                options={chartOptionsBy(condition)}
                zoomAxis={"xAxis"}
            >
            </LinearChart>
        </Container>
    </Sticker>
}
const StateCropsChart: FC<{}> = (props) => {
    const { data  }: CropsConditionState = useTypedSelector(stateCropSelector);
    const { selected } = useTypedSelector(state => state.cropSelector);

    if (selected && array.isEmpty(selected)) {
        return <List className={st.list} rotate={Rotate.Row}>
            {data.fieldConditions.map((c) =>
                <ItemList key={Date.now()} className={st.chart} >
                    <Empty name={c.type}/>
                </ItemList>
            )}
        </List>
    }

    return  <List className={st.list} rotate={Rotate.Row}>
        {data.fieldConditions.map((c) =>
            <ItemList className={st.chart} >
                <StateCropsSticker condition={c}></StateCropsSticker>
            </ItemList>
        )}
    </List>
}

const StateCropsChartWithLoading = stickerLoadingWithCrop(
    stateCropSelector,
    actions => actions.fetchCropsConditions
)(StateCropsChart)

const StateCropsDetailedPage: FC<StateCropsDetailedPage> = ({ children }) => {
    return (
            <HeaderDashboardLayout title={Tx.CropCondition}>
                <StateCropsChartWithLoading/>
            </HeaderDashboardLayout>
    );
};

export default withLayout(StateCropsDetailedPage);
